import React from "react";

import "./style.css";

export const ListContainer = ({ children }) => {
  return <div className={"list__container"}>{children}</div>;
};
